import { useSearchParams } from "react-router-dom"

export const TAB_QUERY_PARAM = "tab"

export function useTabQueryParam(defaultTab = 0, queryParam = TAB_QUERY_PARAM): [number, (newValue: number) => void] {
    const [searchParams, setSearchParams] = useSearchParams()

    const currentTab = searchParams.get(queryParam)
    const tabValue = currentTab ? parseInt(currentTab, 10) : defaultTab

    const handleChangeTab = (newValue: number) => {
        setSearchParams(
            (prevParams) => {
                const newParams = new URLSearchParams(prevParams)
                newParams.set(queryParam, newValue.toString())
                return newParams
            },
            { replace: true },
        )
    }

    return [tabValue, handleChangeTab]
}
